import { WPPost } from '../../types/wordpress';
import { CalendarIcon, ClockIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';
import SaveToMyOrbconButton from '../saved/SaveToMyOrbconButton';
import { decodeHtmlEntities } from '../../utils/htmlEntities';
import { isUnderRevision, versionLineFromHtml } from '../../utils/resourceRevision';
import RevisionNotice from './RevisionNotice';

interface ResourceHeaderProps {
  post: WPPost;
}

export default function ResourceHeader({ post }: ResourceHeaderProps) {
  const publishedDate = new Date(post.date);
  const modifiedDate = new Date(post.modified);
  const isModified = modifiedDate.getTime() > publishedDate.getTime() + 86400000;
  const underRevision = isUnderRevision(post.acf?.under_revision);
  const versionLine =
    versionLineFromHtml(post.excerpt?.rendered) ?? versionLineFromHtml(post.content?.rendered);

  return (
    <div className="resource-heading mb-8">
      <div className="resource-title-row mb-4">
        <h1
          id="resource-title"
          tabIndex={-1}
          className="text-2xl md:text-3xl font-bold text-gray-900 min-w-0 focus-ring rounded-sm"
        >
          {decodeHtmlEntities(post.title.rendered)}
        </h1>
        <SaveToMyOrbconButton
          type="RESOURCE"
          postId={post.id}
          title={decodeHtmlEntities(post.title.rendered)}
          slug={post.slug}
          variant="detail"
        />
      </div>

      <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
        <div className="flex items-center gap-2">
          <CalendarIcon className="h-5 w-5" />
          <span>Published: {format(publishedDate, 'MMMM d, yyyy')}</span>
        </div>
        {isModified && (
          <div className="flex items-center gap-2">
            <ClockIcon className="h-5 w-5" />
            <span>Updated: {format(modifiedDate, 'MMMM d, yyyy')}</span>
          </div>
        )}
      </div>
      {versionLine && <p className="mt-3 text-sm text-gray-700">{versionLine}</p>}
      {underRevision && <RevisionNotice className="mt-3" />}
    </div>
  );
}
